import { AfterViewInit, Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {  Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PasswordValidator } from '../../shared/custom-validators';
import { SharedService } from '../../shared/shared.service';
import { HttpService } from '../../services/main_local.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],

})
export class PasswordComponent implements OnInit,AfterViewInit {
  passwordForm!: FormGroup;
  useid:any;
  password:any;
  authToken: any = null; 
  countryCode:any = '+678';
  mobileNumber:any;
  isHandset$: Observable<boolean> = this.sharedService.isHandset()


  constructor(
     private fb: FormBuilder,
     private router : Router,
     private spinner: NgxSpinnerService,
     private sharedService : SharedService,
     private snackBar:MatSnackBar,
     private route : ActivatedRoute,
     private httpService : HttpService) { 

    }

  hide = true;
  ngOnInit(): void {
    this.passwordForm = this.fb.group({
      password: ['',[Validators.required, PasswordValidator]],
    });
    this.route.queryParams.subscribe((params) => {
      this.mobileNumber = params['mob']; 
    });
  }

  ngAfterViewInit(): void {
    console.log("login");
  }


  keyPressAlphaNumeric(event:any) {

    let inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  keyPressPassword(event:any){
    let inp = String.fromCharCode(event.keyCode);
  
    if (/[><,:;^'"]/.test(inp)) {
      event.preventDefault();
      return false;
    } else {
      
      return true;
    }
  }
  onSubmit(){
    this.spinner.show();
    const body: any = {
      "mobileNumber": this.mobileNumber,
      "isdCode": this.countryCode,
      "password": this.passwordForm.get('password')?.value
    }

    this.httpService.postRequestCall('auth/login', body, this.authToken, {}).subscribe(
      {
       next: (value:any) => {  
        let val:any = value;
        this.spinner.hide();
        this.snackBar.open((val?.message), '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3 * 1000,
        });
        let display_role:any;
        if(value?.data.roles[0] == '6868009'){
          display_role = "Admin";
        }
        if(value?.data.roles[0] == 'doctor'){
          display_role = "Healthcare provider";
        }
        if(value?.data.roles[0] == '224608005'){
          display_role = "Front office staff";
        }
        if(value?.data.roles[0] == '224529009'){
          display_role = "Device Issuer";
        }
        if(value?.data.roles[0] == 'ict'){
          display_role = "Analyst";
        }
        localStorage.setItem('mdr-token',value?.data.token);
        localStorage.setItem('mdr-token-auth',value?.data.token);
        localStorage.setItem('patient-session',value?.data.sessionId);
        localStorage.setItem('patient-number','0');
        localStorage.setItem('userId',value?.data.userId);
        localStorage.setItem('userName',value?.data.username);
        localStorage.setItem('role',value?.data.roles[0]);
        localStorage.setItem("display-role",display_role);
        localStorage.setItem('contactNumber',value?.data.contactNumber);
        if(value?.data.roles[0] == 'ict' || value?.data.roles[0] == '6868009'){
          this.router.navigate(['main/users/list'])
        }
        else{
          this.router.navigate(['main/patients/patientslist'])
        }
       },
       error: (err) => {
        this.errorStatusFun(err);
        if(err.error.message == 'Too many attempts. Please try after 5 mins') {
          this.router.navigate(['login'])
        }
       },
   });
   
  }

  forgotPassword(){
    this.spinner.show();
    const body: any = {
      "mobileNumber": this.mobileNumber,
      "isdCode": this.countryCode,
      "isMobile": true,
      "forgotPass":true
    }
    this.httpService.postRequestCall('auth/verifyUser', body, this.authToken, {}).subscribe({
      next: (value)=>{
        this.spinner.hide();
        let data:any = value;
        this.snackBar.open((data?.message), '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3 * 1000,
        });
        this.router.navigate(['otpverify'],{relativeTo:this.route,queryParams:{mob:this.mobileNumber}});
      },
      error:(err)=>{
        this.errorStatusFun(err);
      }
    })
      
  }

  errorStatusFun(error:any){
    this.spinner.hide();
    this.snackBar.open((error.error.message), '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3 * 1000,
    });
  }

  back(){
    this.router.navigate(['login'])
  }

}
